export default __webpack_public_path__ + "static/media/literatura.11c22dfa.svg";